var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentView,{tag:"component",attrs:{"loading":_vm.isLoadingSelectedTicket}})
}
var staticRenderFns = []

export { render, staticRenderFns }